module.exports = __webpack_public_path__ + "static/ourApproach-eeba25903b5bab714cc36ee2a7230315.jpg";